import { Globe } from "lucide-react";
import { intentIcons, intentLabels, GlobalConnectIntent } from "@/hooks/useGlobalConnect";
import { cn } from "@/lib/utils";

interface GlobalConnectMatchBadgeProps {
  countryFlag: string;
  countryName: string;
  intent?: string;
  className?: string;
  compact?: boolean;
}

export const GlobalConnectMatchBadge = ({
  countryFlag,
  countryName,
  intent,
  className,
  compact = false,
}: GlobalConnectMatchBadgeProps) => {
  return (
    <div
      className={cn(
        "flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/10 border border-primary/20 backdrop-blur-sm",
        className
      )}
    >
      <Globe className="w-3.5 h-3.5 text-primary" />
      <span className="text-sm">{countryFlag}</span>
      {!compact && (
        <span className="text-xs font-medium text-primary">{countryName}</span>
      )}
      {intent && (
        <span className="text-xs">
          {intentIcons[intent as GlobalConnectIntent]}
        </span>
      )}
    </div>
  );
};

// For chat header context
export const GlobalConnectChatHeader = ({
  userFlag,
  partnerFlag,
  timezoneOffset,
}: {
  userFlag: string;
  partnerFlag: string;
  timezoneOffset?: string;
}) => (
  <div className="flex items-center gap-2 px-3 py-2 bg-primary/5 rounded-lg border border-primary/10 text-xs">
    <div className="flex items-center gap-1">
      <span>{userFlag}</span>
      <span className="text-muted-foreground">↔</span>
      <span>{partnerFlag}</span>
    </div>
    {timezoneOffset && (
      <span className="text-muted-foreground">• {timezoneOffset}</span>
    )}
    <span className="text-muted-foreground ml-auto">
      Virtual global connection
    </span>
  </div>
);
